import axios from 'axios';
import { MENU_MANAGER_ENDPOINT } from '@dynameat/constants';

export const getMenuProductDynamicDataListRequest = (saleRateGuid, startDate, endDate) => axios.get(MENU_MANAGER_ENDPOINT(saleRateGuid), { params: { start_date: startDate, end_date: endDate } });
export const updateMenuProductDynamicDataListRequest = (menuProductDynamicDataListToUpdate) => axios.post(MENU_MANAGER_ENDPOINT(), menuProductDynamicDataListToUpdate);
